import { render } from "./SalesChartCard.vue?vue&type=template&id=7af5e030"
import script from "./SalesChartCard.vue?vue&type=script&lang=js"
export * from "./SalesChartCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__